// 短信登录
import React from 'react';
import { Form } from 'antd';
import intl from 'react-intl-universal';
import MD5 from 'crypto-js/md5';

import IconFont from '@/components/IconFont';
import BaseMobileInput from '@/components/BaseMobileInput';
import { getSMSLoginCode } from '@/api/login';

import SubmitButton from '../SubmitButton';
import CodeInput from './CodeInput';
import { validateMobileValue } from '../../helper';
import styles from './index.module.scss';

const Index = (props) => {
  const [formField] = Form.useForm();

  // 获取验证码
  const getSMSCode = () => {
    return formField.validateFields(['mobile']).then(() => {
      return getSMSLoginCode({ mobile: formField.getFieldValue('mobile') });
    });
  };

  // 校验手机号
  const validateMobileInput = (_, val, callback) => {
    callback(validateMobileValue(val));
  };

  // 校验验证码格式
  const validateCode = (_, val, callback) => {
    let errorMessage;
    if (val) {
      if (!/^\d{4}$/.test(val)) {
        errorMessage = intl.get('login_sms_msg3');
      }
    } else {
      errorMessage = intl.get('login_sms_msg4');
    }
    callback(errorMessage);
  };

  // 提交登录
  const handleSubmit = async () => {
    try {
      const { mobile, code } = await formField.validateFields();
      props.onSubmit({ username: mobile, code });
    } catch (_) {
      //
    }
  };

  return (
    <div className={styles.formWrapper}>
      <Form form={formField}>
        <Form.Item name="mobile" rules={[{ validator: validateMobileInput }]}>
          <BaseMobileInput
            selectProps={{
              className: 'login-mobile-area-code',
            }}
            inputProps={{
              prefix: <IconFont type="icon-extend-mobile" />,
              allowClear: true,
              placeholder: intl.get('login_form_mobile_placeholder'),
              className: 'login-mobile-input',
            }}
          />
        </Form.Item>
        <Form.Item name="code" rules={[{ validator: validateCode }]}>
          <CodeInput onSendCode={getSMSCode} />
        </Form.Item>
        <SubmitButton onClick={handleSubmit} />
      </Form>
    </div>
  );
};

export default Index;
